<template>
  <a-modal :title="$t('publish.addNewTag.label')" v-model="show" :destroyOnClose="true" :centered="true"
    :maskClosable="false" @cancel="handleCancel" @ok="handleConfirm">
    <a-form :form="form">
      <a-form-item :label="$t('form.tag.name.label')" v-bind="formItemLayout">
        <a-input :placeholder="$t('form.tag.name.placeholder')"
          v-decorator="['name', { rules: [{ required: true, message: this.$t('form.tag.name.placeholder') }] }]" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { addTag } from "@/api/publish.js";
import { mapGetters } from "vuex";

export default {
  props: ["visible", "type"],
  data() {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    show: {
      get: function () {
        return this.visible;
      },
      set: function () { },
    },
  },
  methods: {
    // 取消
    handleCancel() {
      this.form.resetFields();
      this.$emit("close");
    },
    // 保存
    handleConfirm() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          addTag({ type: this.type, name: values.name }).then((res) => {
            this.$emit("handleConfirm", values, res.data);
          });
        }
      });
    },
  },
};
</script>